import { type Token } from "@koala/sdk/v4";

interface CachedToken {
  token: Token;
  expiresAt: number;
}

const tokenCache = new Map<string, CachedToken>();

function isValidToken(entry: CachedToken | undefined): entry is CachedToken {
  if (!entry) {
    return false;
  }
  return entry.expiresAt > Date.now();
}

export function getCachedToken(origin: string): Token | null {
  const entry = tokenCache.get(origin);
  if (!isValidToken(entry)) {
    if (entry) {
      tokenCache.delete(origin);
    }
    return null;
  }
  return entry.token;
}

export function setCachedToken(origin: string, token: Token) {
  const expiresAt = Date.now() + token.expires_in * 1000;
  tokenCache.set(origin, { token, expiresAt });
}
